<mat-expansion-panel [expanded]="!userControlledAccordion && addressReady && shippingReady && !paymentReady" (opened)="onAccordionToggle()" (closed)="onAccordionToggle()">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon [ngClass]="paymentSectionClass()">{{paymentSectionIcon()}}</mat-icon>
      <span i18n="@@Payment">Payment</span>
    </mat-panel-title>
    <mat-panel-description *ngIf="paymentReady && !enterCreditCard">
      <ng-container *ngIf="invoice" i18n="@@Invoice">Invoice</ng-container>
      <!-- Show `<name> · <brand> ****<last4>` in the header so the
           user can identify at a glance which specific card is
           committed to this order — not just the profile nickname
           (2026-07-09 pass). Reuses `chargeProfileRowLabel(...)`
           so the accordion header and the saved-profile radio row
           always agree. -->
      <ng-container *ngIf="!invoice && cart.chargeProfile">{{chargeProfileRowLabel(cart.chargeProfile)}}</ng-container>
    </mat-panel-description>
    <mat-panel-description *ngIf="!paymentReady" class="section-hint">
      <span i18n="@@Select a payment method">Select a payment method</span>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div class="errorMessage" *ngIf="!(cart.invoiceable && invoice) && cart.paymentErrorMessage.length > 0">
    <h3 color="warn">{{cart.paymentErrorMessage}}</h3>
  </div>

  <div *ngIf="!invoice">
    <!-- Saved charge profiles. Shown alongside the credit-card form now
         (2026-07-09 pass) — previously the whole radio list hid when
         `enterCreditCard` was on, which forced the user to cancel out of
         the form to re-see their saved cards. With both visible the user
         can either pick a saved profile OR fill the new-card form; the
         two are naturally mutually exclusive because `cart.chargeProfile`
         holds one selection at a time. -->
    <div *ngIf="chargeProfileService.objects && chargeProfileService.objects.length > 0">
      <mat-radio-group class="radio-group" (change)="cart.setChargeProfile($event.value); paymentInfoChanged.emit()">
        <mat-radio-button class="checkout-address-option" *ngFor="let chargeProfile of chargeProfileService.objects" [checked]="cart.chargeProfile && chargeProfile.ID === cart.chargeProfile.ID" [value]="chargeProfile">
          <!-- Combined "<name> · <brand> ****<last4>" label. The old
               redundant "Default" text after the name was removed
               (2026-07-09 pass) — the filled/unfilled heart button
               already carries the default state. -->
          <span>{{chargeProfileRowLabel(chargeProfile)}}</span>
          <!-- Heart icon reflects default state directly: filled
               (`favorite`) when this is the org's default,
               outlined (`favorite_border`) when it isn't. Click on a
               non-default row promotes it via the atomic
               `POST /chargeprofile/setdefault` endpoint. -->
          <button mat-icon-button (click)="makeChargeProfileDefault(chargeProfile); $event.stopPropagation()"
                  [attr.title]="chargeProfile.default ? 'Organization default' : 'Set as organization default'">
            <mat-icon [class.saved-payment-heart-active]="chargeProfile.default">{{chargeProfile.default ? 'favorite' : 'favorite_border'}}</mat-icon>
          </button>
          <button mat-icon-button (click)="deleteChargeProfile(chargeProfile); $event.stopPropagation()"><mat-icon>delete</mat-icon></button>
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <button *ngIf="!enterCreditCard" mat-button color="primary" (click)="onEnterCreditCardToggle(true)"><ng-container i18n="@@Enter credit card information">Enter credit card information</ng-container></button>

    <!-- Credit card form -->
    <form class="checkout-form" *ngIf="enterCreditCard">
      <div class="checkout-form-row">
        <mat-form-field appearance="outline" class="checkout-field">
          <mat-label i18n="@@Credit Card Number">Credit Card Number</mat-label>
          <input matInput placeholder="**** **** **** ****" [(ngModel)]="cart.cardNumberWithSpaces" (change)="onPaymentFieldChange()" required [ngModelOptions]="{standalone: true}"/>
        </mat-form-field>
        <mat-form-field appearance="outline" class="checkout-field-sm">
          <mat-label i18n="@@First Name">First Name</mat-label>
          <input matInput [(ngModel)]="cart.firstNamePayment" (change)="onPaymentFieldChange()" required [ngModelOptions]="{standalone: true}"/>
        </mat-form-field>
        <mat-form-field appearance="outline" class="checkout-field-sm">
          <mat-label i18n="@@Last Name">Last Name</mat-label>
          <input matInput [(ngModel)]="cart.lastNamePayment" (change)="onPaymentFieldChange()" required [ngModelOptions]="{standalone: true}"/>
        </mat-form-field>
      </div>
      <div class="checkout-form-row">
        <mat-form-field appearance="outline" class="checkout-field-sm">
          <mat-label i18n="@@Expiration">Expiration</mat-label>
          <input matInput placeholder="**/**" [(ngModel)]="cart.expMonthYear" (change)="onPaymentFieldChange()" required [ngModelOptions]="{standalone: true}"/>
        </mat-form-field>
        <mat-form-field appearance="outline" class="checkout-field-sm">
          <mat-label i18n="@@CCV">CCV</mat-label>
          <input matInput placeholder="****" [(ngModel)]="cart.csc" (change)="onPaymentFieldChange()" required [ngModelOptions]="{standalone: true}"/>
        </mat-form-field>
      </div>
      <div *ngIf="!billingAddressTheSameAsShipping" class="checkout-form-row">
        <mat-form-field appearance="outline" class="checkout-field"><mat-label i18n="@@Address 1">Address 1</mat-label><input matInput [(ngModel)]="cart.address1Payment" (change)="onPaymentFieldChange()" [ngModelOptions]="{standalone: true}"/></mat-form-field>
        <mat-form-field appearance="outline" class="checkout-field"><mat-label i18n="@@Address 2">Address 2</mat-label><input matInput [(ngModel)]="cart.address2Payment" (change)="onPaymentFieldChange()" [ngModelOptions]="{standalone: true}"/></mat-form-field>
      </div>
      <div *ngIf="!billingAddressTheSameAsShipping" class="checkout-form-row">
        <mat-form-field appearance="outline" class="checkout-field-sm"><mat-label i18n="@@City">City</mat-label><input matInput [(ngModel)]="cart.cityPayment" (change)="onPaymentFieldChange()" [ngModelOptions]="{standalone: true}"/></mat-form-field>
        <mat-form-field appearance="outline" class="checkout-field-sm"><mat-label i18n="@@State">State</mat-label><input matInput [(ngModel)]="cart.statePayment" (change)="onPaymentFieldChange()" [ngModelOptions]="{standalone: true}"/></mat-form-field>
        <mat-form-field appearance="outline" class="checkout-field-sm">
          <mat-label i18n="@@Country">Country</mat-label>
          <mat-select [(ngModel)]="cart.countryPayment" (selectionChange)="onPaymentFieldChange()" [ngModelOptions]="{standalone: true}">
            <mat-option *ngFor="let c of countries" [value]="c.code">{{c.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="checkout-field-sm"><mat-label i18n="@@Zip Code">Zip Code</mat-label><input matInput [(ngModel)]="cart.postalCodePayment" (change)="onPaymentFieldChange()" [ngModelOptions]="{standalone: true}"/></mat-form-field>
      </div>
      <mat-slide-toggle color="primary" (change)="onBillingAddressSameToggle()" [(ngModel)]="billingAddressTheSameAsShipping" [ngModelOptions]="{standalone: true}" i18n="@@Is Billing Address The Same As Shipping">Is Billing Address The Same As Shipping</mat-slide-toggle>
      <mat-slide-toggle color="primary" (change)="toggleSavePaymentInfoAsChargeProfile()" [checked]="savePaymentInfoAsChargeProfile" i18n="@@Save payment information as charge profile">Save payment information as charge profile</mat-slide-toggle>
      <mat-form-field appearance="outline" class="checkout-field" *ngIf="savePaymentInfoAsChargeProfile">
        <mat-label i18n="@@Charge profile name">Charge profile name</mat-label>
        <input matInput [ngModel]="savePaymentInfoAsChargeProfileName" (ngModelChange)="onSavePaymentInfoAsChargeProfileNameChange($event)" [ngModelOptions]="{standalone: true}"/>
      </mat-form-field>

      <!-- Immediate "Save charge profile" affordance (2026-07-09 pass).
           Tokenizes the entered card RIGHT NOW rather than deferring the
           save until `Place order`. On success the form collapses back
           to the saved-profile radio list with the new row selected —
           the user gets a durable saved card even if they abandon the
           checkout, and any future cart starts with this option
           available. The existing `savePaymentInfoAsChargeProfile`
           toggle above is still honoured for users who prefer the
           deferred flow. -->
      <div class="save-profile-row">
        <button type="button"
                *ngIf="saveProfileState === 'IDLE'"
                mat-stroked-button color="primary"
                [disabled]="!canSaveChargeProfile"
                (click)="saveChargeProfileNow()">
          <mat-icon>save</mat-icon>
          <span i18n="@@Save charge profile">Save charge profile</span>
        </button>
        <span *ngIf="saveProfileState === 'IDLE' && !canSaveChargeProfile" class="save-profile-hint" i18n="@@Fill in the card details to enable save">Fill in the card details to enable save</span>
        <span *ngIf="saveProfileState === 'SAVING'" class="save-profile-status">
          <mat-progress-spinner color="primary" mode="indeterminate" diameter="16"></mat-progress-spinner>
          <span i18n="@@Saving charge profile">Saving charge profile</span>
        </span>
        <span *ngIf="saveProfileState === 'SAVED'" class="save-profile-status save-profile-status-saved">
          <mat-icon>check_circle</mat-icon>
          <span i18n="@@Charge profile saved">Charge profile saved</span>
        </span>
        <span *ngIf="saveProfileState === 'ERROR'" class="save-profile-status save-profile-status-error">
          <mat-icon>error_outline</mat-icon>
          <span>{{saveProfileErrorMessage}}</span>
          <button type="button" mat-button (click)="saveChargeProfileNow()" i18n="@@Retry">Retry</button>
        </span>
      </div>

      <!-- Cancel affordance — only offered when there's at least one
           saved profile to fall back on, so the user isn't stranded
           without any payment method after dismissing the form. -->
      <button type="button"
              *ngIf="chargeProfileService.objects && chargeProfileService.objects.length > 0"
              mat-button
              (click)="onEnterCreditCardToggle(false)"
              i18n="@@Cancel add card">Cancel add card</button>
    </form>
  </div>
  <div *ngIf="cart.invoiceable" class="payment-method-chooser">
    <mat-radio-group [(ngModel)]="paymentMethod" (change)="onPaymentMethodChange($event.value)" [ngModelOptions]="{standalone: true}">
      <mat-radio-button value="card" class="payment-method-radio" i18n="@@Pay with credit card">Pay with credit card</mat-radio-button>
      <mat-radio-button value="invoice" class="payment-method-radio" i18n="@@Invoice">Invoice</mat-radio-button>
    </mat-radio-group>
  </div>
</mat-expansion-panel>
